/* eslint-disable no-console */
import React from 'react'
import { Row, Col, Button, Alert } from 'antd'
import DeleteIcon from '../../../../../assets/images/wnb/clear-bins-icon.svg'
import AcContainer from './acContainer'

const INPUTPROPS = {
  className: 'ac-ip',
  type: 'number',
  size: 'small',
  bordered: false,
  // min: 1,
  // max: 10,
  controls: false,
}

const AcType764 = (props) => {
  const INPUTDISABLED = props.ccPlanModalVisible || props.copy || props.disableInputs
  const ULDDISABLED = props.disableInputs || props.copy
  let uldAssigned = []
  const getUld = (uld_type, wgt) => {
    const find = uld_type && props.ulds?.find(uld => {
      if (uld_type == uld?.uld_type?.substring(0,3) && parseFloat(uld.wgt) == parseFloat(wgt) && !uldAssigned.includes(uld.id)) {
        uldAssigned.push(uld.id)
        return true
      }
    })
    return find ? find.uld_type : ''
  }
  
  return (
    <div>
      <div className='WnB-alert'>
        {props?.optimal && (<Alert type='success' className='WnB-alert-success' message='Optimal Configuration' showIcon />)}
        {!props?.optimal && (<Alert type='error' className='WnB-alert-error' message='Suboptimal Configuration: The use of LD3s causes unuseable space on a 767' showIcon />)}
      </div>

      <div className={`parent-div-764-1 ${props.viewMode == 'sm' ? 'parent-div-764-sm' : ''}`}>
        <div className='ac-top-wrapper ac764-top-wrapper'>
          <div className='container-wrapper airline-ac764-top'>
            <Row gutter={[0]} wrap={false} align='middle'>
              <Col flex='860px'>
              </Col>
              <Col flex='106px' className='f-middle'>
                <Button className='bin-button' onClick={props.clearBin} icon={<div className='bin-icon'><img src={DeleteIcon} alt='delete' /></div>}></Button>
              </Col>
              <Col flex='950px'>
                <Row gutter={[4]} wrap={false}>
                  <Col flex={1}>
                    <AcContainer
                      ac_type='764'
                      name='24P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p24}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p24', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p24, props.position?.pallet?.p24)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p24}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p24', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r28 || props.position?.cargo?.l28 || props.position?.cargo?.r27 || props.position?.cargo?.l27}
                      // isBag={props.bag_wgt == props.position?.pallet?.p23}                
                    />
                  </Col>
                  <Col flex={1}>
                    <AcContainer
                      ac_type='764'
                      name='23P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p23}
                      uldOnChange={(e) => { console.log(e); props.onChange(e, 'p23', 'pallet_uld') }}
                      uld={getUld(props.position?.pallet_uld?.p23, props.position?.pallet?.p23)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p23}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p23', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.l25 || props.position?.cargo?.r25 || props.position?.cargo?.r26 || props.position?.cargo?.l26}
                      // isBag={props.bag_wgt == props.position?.pallet?.p23}                
                    />
                  </Col>
                  <Col flex={1}>
                    <AcContainer
                      ac_type='764' name='22P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p22}
                      uldOnChange={(e) => props.onChange(e, 'p22', 'pallet_uld')}
                      uld={getUld(props.position?.pallet_uld?.p22, props.position?.pallet?.p22)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p22}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p22', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r23 || props.position?.cargo?.l23 || props.position?.cargo?.l24 || props.position?.cargo?.r24}
                    />
                  </Col>
                  <Col flex={1}>
                    <AcContainer
                      ac_type='764' name='21P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p21}
                      uldOnChange={(e) => props.onChange(e, 'p21', 'pallet_uld')}
                      uld={getUld(props.position?.pallet_uld?.p21, props.position?.pallet?.p21)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p21}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p21', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r22 || props.position?.cargo?.l22 || props.position?.cargo?.r21 || props.position?.cargo?.l21}
                      className={`${INPUTPROPS.className} ${(props.position?.pallet?.p21) > 6860 ? 'bg-danger' : ''}`}

                    />
                  </Col>
                  <Col flex='auto'>
                    <AcContainer
                      ac_type='764' name='11P'
                      uldSelect={true}
                      uldValue={props.position?.pallet_uld?.p11}
                      uldOnChange={(e) => props.onChange(e, 'p11', 'pallet_uld')}
                      uld={getUld(props.position?.pallet_uld?.p11, props.position?.pallet?.p11)}
                      uldDisabled={ULDDISABLED}
                      ipValue={props.position?.pallet?.p11}
                      onSubmit={props.onSubmit}
                      ipOnChange={(e) => props.onChange(e, 'p11', 'pallet')}
                      ipDisabled={INPUTDISABLED || props.position?.cargo?.r11 || props.position?.cargo?.l11 || props.position?.cargo?.l12 || props.position?.cargo?.r12}
                      className={`${INPUTPROPS.className} ${(props.position?.pallet?.p11) > 6860 ? 'bg-danger' : ''}`}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
        <div className='airline-ac-contents airline-ac764-contents'>
          <div className='container-wrapper'>
            <Row gutter={[0]} wrap={false}>
              {/* LHS */}
              <Col flex='860px'>
                <Row gutter={[8, 16]}>
                  {/* TOP ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764' name='BULK'
                          ipDisabled={ULDDISABLED}
                          ipValue={props.position?.bulk}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, null, 'bulk')}
                        // ipDisabled={INPUTDISABLED}
                        />
                      </Col>
                      <Col flex={'20px'} className='crew-rest'>CR</Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='41L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l41}
                          uldOnChange={(e) => props.onChange(e, 'l41', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l41, props.position?.cargo?.l41)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l41}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l41', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p41}
                          isBag={props.bag_wgt == props.position?.cargo?.l41}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l41 + props.position?.cargo?.r41) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='37L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l37}
                          uldOnChange={(e) => props.onChange(e, 'l37', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l37, props.position?.cargo?.l37)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l37}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l37', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p41}
                          isBag={props.bag_wgt == props.position?.cargo?.l37}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l37 + props.position?.cargo?.r37) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='36L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l36}
                          uldOnChange={(e) => props.onChange(e, 'l36', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l36, props.position?.cargo?.l36)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l36}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l36', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34}
                          isBag={props.bag_wgt == props.position?.cargo?.l36}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l36 + props.position?.cargo?.r36) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='35L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l35}
                          uldOnChange={(e) => props.onChange(e, 'l35', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l35, props.position?.cargo?.l35)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l35}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l35', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34 || props.position?.pallet?.p33}
                          isBag={props.bag_wgt == props.position?.cargo?.l35}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l35 + props.position?.cargo?.r35) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='34L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l34}
                          uldOnChange={(e) => props.onChange(e, 'l34', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l34, props.position?.cargo?.l34)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l34}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l34', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p33}
                          isBag={props.bag_wgt == props.position?.cargo?.l34}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='33L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l33}
                          uldOnChange={(e) => props.onChange(e, 'l33', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l33, props.position?.cargo?.l33)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l33}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l33', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p32}
                          isBag={props.bag_wgt == props.position?.cargo?.l33}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='32L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l32}
                          uldOnChange={(e) => props.onChange(e, 'l32', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l32, props.position?.cargo?.l32)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l32}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l32', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p31 || props.position?.pallet?.p32}
                          isBag={props.bag_wgt == props.position?.cargo?.l32}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='31L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l31}
                          uldOnChange={(e) => props.onChange(e, 'l31', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l31, props.position?.cargo?.l31)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l31}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l31', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p31}
                          isBag={props.bag_wgt == props.position?.cargo?.l31}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {/* BOTTOM ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex={'94px'}></Col>
                      <Col flex={'20px'} className='crew-rest'>CR</Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='41R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r41}
                          uldOnChange={(e) => props.onChange(e, 'r41', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r41, props.position?.cargo?.r41)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r41}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r41', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p41 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l41)}
                          isBag={props.bag_wgt == props.position?.cargo?.r41}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l41 + props.position?.cargo?.r41) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='37R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r37}
                          uldOnChange={(e) => props.onChange(e, 'r37', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r37, props.position?.cargo?.r37)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r37}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r37', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p41 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l37)}
                          isBag={props.bag_wgt == props.position?.cargo?.r37}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l37 + props.position?.cargo?.r37) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='36R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r36}
                          uldOnChange={(e) => props.onChange(e, 'r36', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r36, props.position?.cargo?.r36)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r36}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r36', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l36)}
                          isBag={props.bag_wgt == props.position?.cargo?.r36}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l36 + props.position?.cargo?.r36) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='35R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r35}
                          uldOnChange={(e) => props.onChange(e, 'r35', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r35, props.position?.cargo?.r35)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r35}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r35', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p34 || props.position?.pallet?.p33 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l35)}
                          isBag={props.bag_wgt == props.position?.cargo?.r35}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l35 + props.position?.cargo?.r35) >= 2968 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='34R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r34}
                          uldOnChange={(e) => props.onChange(e, 'r34', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r34, props.position?.cargo?.r34)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r34}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r34', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p33 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l34)}
                          isBag={props.bag_wgt == props.position?.cargo?.r34}

                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='33R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r33}
                          uldOnChange={(e) => props.onChange(e, 'r33', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r33, props.position?.cargo?.r33)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r33}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r33', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p32 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l33)}
                          isBag={props.bag_wgt == props.position?.cargo?.r33}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='32R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r32}
                          uldOnChange={(e) => props.onChange(e, 'r32', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r32, props.position?.cargo?.r32)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r32}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r32', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p31 || props.position?.pallet?.p32 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l32)}
                          isBag={props.bag_wgt == props.position?.cargo?.r32}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='31R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r31}
                          uldOnChange={(e) => props.onChange(e, 'r31', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r31, props.position?.cargo?.r31)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r31}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r31', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p31 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l31)}
                          isBag={props.bag_wgt == props.position?.cargo?.r31}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              {/* Mid */}
              <Col flex='106px'>
              </Col>
              {/* RHS */}
              <Col flex='950px'>
                <Row gutter={[8, 16]}>
                  {/* TOP ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764' name='28L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l28}
                          uldOnChange={(e) => props.onChange(e, 'l28', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l28, props.position?.cargo?.l28)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l28}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l28', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24}
                          isBag={props.bag_wgt == props.position?.cargo?.l28}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764' name='27L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l27}
                          uldOnChange={(e) => props.onChange(e, 'l27', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l27, props.position?.cargo?.l27)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l27}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l27', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24}
                          isBag={props.bag_wgt == props.position?.cargo?.l27}
                        />
                      </Col>

                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='26L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l26}
                          uldOnChange={(e) => props.onChange(e, 'l26', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l26, props.position?.cargo?.l26)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l26}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l26', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p23}
                          isBag={props.bag_wgt == props.position?.cargo?.l26}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='25L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l25}
                          uldOnChange={(e) => props.onChange(e, 'l25', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l25, props.position?.cargo?.l25)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l25}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l25', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p23}
                          isBag={props.bag_wgt == props.position?.cargo?.l25}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='24L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l24}
                          uldOnChange={(e) => props.onChange(e, 'l24', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l24, props.position?.cargo?.l24)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l24}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l24', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22}
                          isBag={props.bag_wgt == props.position?.cargo?.l24}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764'
                          name='23L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l23}
                          uldOnChange={(e) => props.onChange(e, 'l23', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l23, props.position?.cargo?.l23)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l23}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l23', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22}
                          isBag={props.bag_wgt == props.position?.cargo?.l23}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='22L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l22}
                          uldOnChange={(e) => props.onChange(e, 'l22', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l22, props.position?.cargo?.l22)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l22}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l22', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p21}
                          isBag={props.bag_wgt == props.position?.cargo?.l22}
                          className={`${INPUTPROPS.className} ${(props.position?.pallet?.p21) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='21L'
                          uldSelect={true}
                          fqa={true}
                          uldValue={props.position?.cargo_uld?.l21}
                          uldOnChange={(e) => props.onChange(e, 'l21', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l21, props.position?.cargo?.l21)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l21}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l21', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p21}
                          isBag={props.bag_wgt == props.position?.cargo?.l21}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l21 || props.position?.cargo?.r21) > 3225 || (props.position?.pallet?.p21) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='12L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l12}
                          uldOnChange={(e) => props.onChange(e, 'l12', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l12, props.position?.cargo?.l12)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l12}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l12', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11}
                          isBag={props.bag_wgt == props.position?.cargo?.l12}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l12 || props.position?.cargo?.r12) > 3225 || (props.position?.pallet?.p11) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={'auto'}>
                        <AcContainer
                          ac_type='764'
                          name='11L'
                          uldSelect={true}
                          uldValue={props.position?.cargo_uld?.l11}
                          uldOnChange={(e) => props.onChange(e, 'l11', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.l11, props.position?.cargo?.l11)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.l11}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'l11', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11}
                          isBag={props.bag_wgt == props.position?.cargo?.l11}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l12 || props.position?.cargo?.r12) > 3225 || (props.position?.pallet?.p11) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {/* BOTTOM ROW */}
                  <Col xs={24}>
                    <Row gutter={[4]} wrap={false}>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764' name='28R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r28}
                          uldOnChange={(e) => props.onChange(e, 'r28', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r28, props.position?.cargo?.r28)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r28}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r28', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l28)}
                          isBag={props.bag_wgt == props.position?.cargo?.r28}
                        />
                      </Col>
                      <Col flex='auto'>
                        <AcContainer
                          ac_type='764' name='27R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r27}
                          uldOnChange={(e) => props.onChange(e, 'r27', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r27, props.position?.cargo?.r27)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r27}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r27', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p24 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l27)}
                          isBag={props.bag_wgt == props.position?.cargo?.r27}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='26R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r26}
                          uldOnChange={(e) => props.onChange(e, 'r26', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r26, props.position?.cargo?.r26)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r26}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r26', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p23 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l26)}
                          isBag={props.bag_wgt == props.position?.cargo?.r26}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764' name='25R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r25}
                          uldOnChange={(e) => props.onChange(e, 'r25', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r25, props.position?.cargo?.r25)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r25}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r25', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p23 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l25)}
                          isBag={props.bag_wgt == props.position?.cargo?.r25} />
                      </Col>

                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='24R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r24}
                          uldOnChange={(e) => props.onChange(e, 'r24', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r24, props.position?.cargo?.r24)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r24}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r24', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l24)}
                          isBag={props.bag_wgt == props.position?.cargo?.r24}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='23R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r23}
                          uldOnChange={(e) => props.onChange(e, 'r23', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r23, props.position?.cargo?.r23)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r23}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r23', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p22 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l23)}
                          isBag={props.bag_wgt == props.position?.cargo?.r23}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='22R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r22}
                          uldOnChange={(e) => props.onChange(e, 'r22', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r22, props.position?.cargo?.r22)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r22}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r22', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p21 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l22)}
                          isBag={props.bag_wgt == props.position?.cargo?.r22}
                          className={`${INPUTPROPS.className} ${(props.position?.pallet?.p21) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764' name='21R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r21}
                          uldOnChange={(e) => props.onChange(e, 'r21', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r21, props.position?.cargo?.r21)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r21}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r21', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p21 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l21)}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l21 || props.position?.cargo?.r21) > 3225 || (props.position?.pallet?.p21) > 6860 ? 'bg-danger' : ''}`}
                          isBag={props.bag_wgt == props.position?.cargo?.r21} />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='12R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r12}
                          uldOnChange={(e) => props.onChange(e, 'r12', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r12, props.position?.cargo?.r12)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r12}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r12', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l12)}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l12 || props.position?.cargo?.r12) > 3225 || (props.position?.pallet?.p11) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                      <Col flex={1}>
                        <AcContainer
                          ac_type='764'
                          name='11R'
                          // uldSelect={true}
                          uldValue={props.position?.cargo_uld?.r11}
                          uldOnChange={(e) => props.onChange(e, 'r11', 'cargo_uld')}
                          uld={getUld(props.position?.cargo_uld?.r11, props.position?.cargo?.r11)}
                          uldDisabled={ULDDISABLED}
                          ipValue={props.position?.cargo?.r11}
                          onSubmit={props.onSubmit}
                          ipOnChange={(e) => props.onChange(e, 'r11', 'cargo')}
                          ipDisabled={INPUTDISABLED || props.position?.pallet?.p11 || ['LD3', 'RKN', 'LD4', 'LD8'].includes(props.position?.cargo_uld?.l11)}
                          className={`${INPUTPROPS.className} ${(props.position?.cargo?.l11 || props.position?.cargo?.r11) > 3225 || (props.position?.pallet?.p11) > 6860 ? 'bg-danger' : ''}`}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className='door-block'>
              <Row gutter={[0]} wrap={false}>
                {/* LHS */}
                <Col flex='860px'>
                  <Row gutter={[4]} wrap={false}>
                    <Col flex={'94px'} />
                    <Col flex={'20px'} />
                    <Col flex='1 1 0'><div className='doors'>Door</div></Col>
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                  </Row>
                </Col>
                {/* Mid */}
                <Col flex='106px'>
                </Col>
                {/* RHS */}
                <Col flex='950px'>
                  <Row gutter={[4]} wrap={false}>
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                    <Col flex='2 1 0'><div className='doors'>Door</div></Col>
                    <Col flex='1 1 0' />
                    <Col flex='1 1 0' />
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <ul className='ac-notes1'>
          <li>Plan heavy LD2s and FQAs wherever possible</li>
          <li>Limit the amount of heavy PMCs planned for FWD compartment</li>
        </ul>
      </div>
    </div>

  )
}
export default AcType764

